module.exports = __webpack_public_path__ + "static/dark-yellow1-1f31f17ce8ce6e717e11965f5023f63f.png";